<epc-shop-the-commercial-list
  [list]="list$ | async"
  class="flex-grow-1 flex-mg-grow-auto"
>
</epc-shop-the-commercial-list>
